var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$currentUserCan(_vm.$permissions.PERM_VIEW_ANY_CATEGORIES) && _vm.category)?_c('span',{staticClass:"mx-2"},[_c('router-link',{attrs:{"to":{ name: 'View Category', params: { id: _vm.category.id } }}},[_vm._v(" "+_vm._s(`${_vm.category.name}`)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }